const LandingPage = () => {
    return (
        <div className="p-2">
            <h1>Provide App ID in url to go to simulation</h1>
        </div>
    )
}

export default LandingPage;